import React, { memo, useState, useEffect } from 'react';
import styles from './filterSimcards.module.scss';
import FilterContent from '../../../shared/components/FilterContent';
import Button from '../../../shared/components/Button';
import Input from '../../../shared/components/Input';
import CustomSelect from '../../../shared/components/CustomSelect/CustomSelect';
import CreateSimcard from '../CreateSimcard';
import { useTranslation } from 'react-i18next';
import { defaultFilters } from '../SimcardLoader/SimcardLoader';
import DatePicker from '../../../shared/components/DatePicker';

const FiltersSimcard = ({ 
    setSimcardsFilters, 
    filters, 
    simCards: { fetching, fetchingExport, statuses, substatuses, fetchingSubstatuses, fetchingStatuses},
    getExportSimcardsRequest,
    filtersToUseInQuery,
    closePingEventExportSimcards,
    getSimcardsStatusesRequest,
    getSimcardsSubstatusesRequest
}) => {
    const { t } = useTranslation(['home', 'devices']);
    const [searchTerm, setSearchTerm] = useState('');
    const [desde, setDesde] = useState(null);
    const [hasta, setHasta] = useState(null);
    const [provider, setProvider] = useState({ value: '', label: 'Proveedor' });
    const [status, setStatus] = useState({ value: '', label: 'Estado' });
    const [substatus, setSubstatus] = useState({ value: '', label: 'Subestado' });
    const [enabled, setEnabled] = useState({ value: '', label: 'Habilitación' });

    const handleSearchChange = ev => setSearchTerm(ev.target.value);
    const handleDesde = selectedDate => setDesde(selectedDate);
    const handleHasta = selectedDate => setHasta(selectedDate);
    const handleStatusChange = selectedOption => {
        setStatus(selectedOption || { value: '', label: 'Estado' });
    };
    
    const handleSubstatusChange = selectedOption => {
        setSubstatus(selectedOption || { value: '', label: 'Subestado' });
    };
    
    const handleEnabledChange = option => {
        setEnabled(option || { value: '', label: 'Habilitación' });
    };

    const filterSimcard = () => {
        const filters = {
            search: searchTerm,
            from_created: desde ? formatDate(desde) : null,
            to_created: hasta ? formatDate(hasta) : null,
            status: status.value ? { _id: status.value, name: status.label } : null,
            enabled: enabled.value !== '' ? enabled : null,
            substatus: substatus.value ? { _id: substatus.value, name: substatus.label } : null
        };
        setSimcardsFilters(filters);
    };
    
    const pad2 = n => String(n).padStart(2, '0');
    const formatDate = date => {
        if (!date) return null;
        if (!(date instanceof Date)) return null;
        const y = date.getFullYear();
        const m = pad2(date.getMonth() + 1);
        const d = pad2(date.getDate());
        return `${y}-${m}-${d}`;
    };
    
    const exportSimcard = () => {
        const timeZone = new Date().getTimezoneOffset();
        const exportFilters = {
            ...defaultFilters,
            ...filtersToUseInQuery,
            tz: timeZone
        };
        getExportSimcardsRequest(exportFilters);
    };

    const handleClear = () => {
        setSearchTerm('');
        setDesde('');
        setHasta('');
        setStatus('');
        setEnabled('');
        setSimcardsFilters({
            search: '',
            from_created: '',
            to_created: '',
            status: '',
            enabled: '',
            substatus: ''
        });
    };

    useEffect(() => {
        setSearchTerm(filters.search || '');
        setDesde(filters.from_created || '');
        setHasta(filters.to_created || '');
        setStatus(filters.status || '');
        setSubstatus(filters.substatus || '');
        setEnabled(filters.enabled || '');
    }, [filters]);

    useEffect(() => {
        return () => closePingEventExportSimcards();
    }, [])

    useEffect(() => {
    
        getSimcardsStatusesRequest();
    }, [getSimcardsStatusesRequest])


    useEffect(() => {
        if (filters) {
            setSearchTerm(filters.search || '');
            setDesde(filters.from_created || null);
            setHasta(filters.to_created || null);
            
            if (filters.status && filters.status._id) {
                setStatus({
                    value: filters.status._id,
                    label: filters.status.name || 'Estado'
                });
            } else {
                setStatus({ value: '', label: 'Estado' });
            }
            
            if (filters.substatus && filters.substatus._id) {
                setSubstatus({
                    value: filters.substatus._id,
                    label: filters.substatus.name || 'Subestado'
                });
            } else {
                setSubstatus({ value: '', label: 'Subestado' });
            }
            
            if (filters.enabled && filters.enabled.value !== undefined) {
                setEnabled(filters.enabled);
            } else {
                setEnabled({ value: '', label: 'Habilitación' });
            }
        }
    }, [filters])

    const enabledOptions = [
        { value: '', label: 'Habilitación' },
        { value: true, label: 'Habilitado' },
        { value: false, label: 'Deshabilitado' }
    ];


    const [statusOptions, setStatusOptions] = useState([{ value: '', label: 'Todos los estados' }]);
    
    useEffect(() => {
        if (Array.isArray(statuses) && statuses.length > 0) {
    
            const options = [
                { value: '', label: 'Todos los estados' },
                ...statuses.map(status => ({
                    value: status._id || status.id,
                    label: status.name
                }))
            ];
            setStatusOptions(options);
        }
    }, [statuses]);
    
    const findOptionByValue = (options, value) => {
        return options.find(option => option.value === value) || { value: '', label: 'Todos' };
    };

    return (
        <div className={styles.header}>
             <div className={styles.arriba}>
           
            <Button onClick={exportSimcard} className={styles.buttonArchivo} loading={fetchingExport}>
    
                <span>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="18" 
                    height="15" 
                    viewBox="13 0 40 40" 
                    fill="none"
                >
                    <path 
                        d="M24 4V30M24 30L14 20M24 30L34 20M10 36H38" 
                        stroke="white" 
                        strokeWidth="4" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    />
                </svg></span> Exportar Simcards
                </Button>

            <CreateSimcard />
            </div>
            <div className={styles.abajo}>
            <FilterContent className={styles.filterContent}>
            <div className={styles.searchInput}>
            <Input 
                    placeholder="ICCID, número, proveedor" 
                    value={searchTerm} 
                    onChange={handleSearchChange} 
                />
                        <svg 
                            className={styles.searchIcon} 
                            width="16" 
                            height="16" 
                            viewBox="0 0 20 20" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M14 14L11 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
               
               
                 <DatePicker
                    selected={desde}
                    onChange={handleDesde}
                    placeholderText="Desde"
                    className={styles.datePicker}
                    placeholder="Desde"
                    dateFormat="dd/MM/yyyy"
                    key={`desde-${desde || 'empty'}`}
                />
                <DatePicker
                    selected={hasta}
                    onChange={handleHasta}
                    placeholder="Hasta"
                    className={styles.datePicker}
                    dateFormat="dd/MM/yyyy"
                    key={`hasta-${hasta || 'empty'}`}
                />
                  
                  <CustomSelect
                    options={statusOptions}
                    value={status.value ? status : null}
                    onChange={handleStatusChange}
                    placeholder="Estado"
                    isClearable={!!status.value}
                  />
             
                <CustomSelect
                    placeholder="Habilitación"
                    value={enabled}
                    onChange={handleEnabledChange}
                    options={enabledOptions}
                    isSearchable={false}
                />
                <Button onClick={handleClear} className={styles.buttonLimpiar} >
                    Limpiar
                </Button>
 <Button onClick={filterSimcard} className={styles.buttonFilter} loading={fetching}>
                    Aplicar
                </Button>

                
             
            </FilterContent>
            </div>
        </div>
    );
};

export default memo(FiltersSimcard);
